import React, { useState, useEffect } from 'react';
import { Wifi, WifiOff } from 'lucide-react';

const ConnectionStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <div 
      className="flex flex-col items-center gap-0.5"
      data-testid="connection-status"
    >
      {isOnline ? (
        <>
          <Wifi size={16} className="text-emerald-500" />
          <span className="text-[10px] font-medium text-emerald-600">Online</span>
        </>
      ) : (
        <>
          <WifiOff size={16} className="text-red-500 animate-pulse" />
          <span className="text-[10px] font-medium text-red-600 animate-pulse">Offline</span>
        </>
      )}
    </div>
  );
};

export default ConnectionStatus;
